import Settings from '@/views/Settings/Settings'

export default {
  name: 'SettingsMobile',
  mixins: [Settings],
  computed: {
    computedToursMobile () {
      return this.computedTours.map(tour => ({
        label: `${this.$t(tour.title)}`,
        value: { id: tour.id, version: tour.version }
      }))
    }
  }
}
